module.exports = __webpack_public_path__ + "img/c4255d1e2b44db93660332ec4c5c5b7b.png";